import { gql } from "@apollo/client";

export const QUERY_SOURCES = gql`
  query connectors($tenantID: ID!) {
    connectors(tenantID: $tenantID) {
      id
      name
      active
      type
      account_count
    }
  }
`;

export const CREATE_SOURCE = gql`
  mutation sourcesCreate($name: String!, $tenantID: ID!) {
    sourcesCreate(name: $name, tenantID: $tenantID) {
      id
      name
    }
  }
`;

export const DELETE_SOURCE = gql`
  mutation sourcesDelete($id: ID!, $tenantID: ID!) {
    sourcesDelete(id: $id, tenantID: $tenantID)
  }
`;

export const UPDATE_SOURCE = gql`
  mutation sourcesUpdate($name: String!, $id: ID!, $tenantID: ID!) {
    sourcesUpdate(name: $name, id: $id, tenantID: $tenantID) {
      id
      name
    }
  }
`;

export const QUERY_ACCOUNTS = gql`
  query accounts($connector_type: String!, $tenantID: ID!) {
    accounts(connector_type: $connector_type, tenantID: $tenantID) {
      id
      status
      name
      friendly_name
      url: profile_image_url
      profile_image_url
      handles {
        id
        friendly_name
        screen_name
        profile_image_url
        access
        download_data
      }
    }
  }
`;

export const DELETE_ACCOUNT = gql`
  mutation deleteAccount($id: ID!, $connector_type: String!, $tenantID: ID!) {
    deleteAccount(id: $id, connector_type: $connector_type, tenantID: $tenantID)
  }
`;

export const QUERY_fbAuthURI = gql`
  query fbAuthURI($env: EnvForRedirect) {
    fbAuthURI(env: $env)
  }
`;

export const QUERY_getPages = gql`
  query getPages($fbAccessToken: String!, $tenantID: ID!) {
    getUserFacebookPages(fbAccessToken: $fbAccessToken, tenantID: $tenantID) {
      data {
        fb {
          id
          username
          name
          image
        }
        ig {
          id
          name
          username
          image
        }
        linked
        CanPullIGStoryMetric
        hasIGAccount
      }
      sessionID
    }
  }
`;

export const LINK_FACEBOOK = gql`
  mutation link($sessionID: String!, $pageIDs: [ID]!) {
    linkFBPages(sessionID: $sessionID, pageIDs: $pageIDs) {
      message
      success
    }
  }
`;
